const styles = {
  Show: {
    display: 'flex',
    transition: 'all 0.3s ease-in-out !important',
  },

  Hide: {
    display: 'none',
    transition: 'all 0.3s ease-in-out !important',
  },
  SupplierTableButtons: {
    width: '11.11vw !important',
  },
  Button: {
    padding: '3px 10px !important',
    fontSize: '12px !important',
    marginRight: '8px !important',
    fontWeight: 'normal !important',
    letterSpacing: '0.5px !important',
    fontFamily: 'Poppins !important',
    color: 'rgb(255, 255, 255) !important',
    borderRadius: '2.5px !important',
  },
  InsertButton: {
    display: 'inline-block !important',
    color: 'black !important',
    backgroundColor: 'aquamarine !important',
    whiteSpace: 'normal !important',
    fontSize: '13px !important',
    padding: '3px 20px !important',
    marginRight: '7px !important',
    width: '8.9rem !important',
  },
  DeleteButton: {
    padding: '3.6px 10px !important',
    backgroundColor: 'rgb(255 0 0) !important',
  },
  UpdateButton: {
    width: '4.5vw !important',
    backgroundColor: '#097ddb !important',
  },
};

export default styles;
